import React from 'react';
import { Business } from '@mui/icons-material';
import { PageContainer, Content } from '../PageTemplate';
import Form from '../../components/form';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const GradientHero = styled.div`
  background: linear-gradient(
    150deg,
    #ff80b5 0%,
    #9089fc 20%,
    #ff80b5 40%,
    #40c9ff 60%,
    #a5fecb 80%,
    #9089fc 100%
  );
  background-size: 200% 200%;
  animation: gradientMove 15s ease infinite;
  padding: 16rem 2rem 8rem 2rem;
  margin-top: -80px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      circle at 50% 50%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    filter: blur(60px);
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    padding: 12rem 1rem 6rem 1rem;
    
    h1 {
      font-size: 2.5rem !important;
    }
    
    p {
      font-size: 1rem !important;
      padding: 0 1rem;
    }
  }
`;

const AboutSection = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 2rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const StoryText = styled(motion.p)`
  font-size: 1.25rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.text};
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const AboutUs = () => {
  return (
    <PageContainer>
      <GradientHero>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Business sx={{ 
            fontSize: 64, 
            marginBottom: 2,
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
          }} />
          <motion.h1
            style={{
              fontSize: '3.5rem',
              marginBottom: '1.5rem',
              fontWeight: 700,
              position: 'relative',
              zIndex: 2
            }}
          >
            About Us
          </motion.h1>
          <motion.p
            style={{
              fontSize: '1.25rem',
              maxWidth: '800px',
              margin: '0 auto',
              opacity: 0.9,
              lineHeight: 1.6,
              position: 'relative',
              zIndex: 2
            }}
          >
            Our story and mission
          </motion.p>
        </motion.div>
      </GradientHero>

      <Content>
        <AboutSection>
          <StoryText
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            ServTrackr was born from a simple observation: service businesses needed a better way to manage their operations. Our founders, having worked in various service industries, experienced firsthand the challenges of juggling multiple tools and systems to run their businesses effectively.
          </StoryText>
          
          <StoryText
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Today, we're building the most comprehensive service business management platform that combines scheduling, customer management, billing, and team coordination into one seamless solution. Our mission is to empower service businesses with the tools they need to grow and succeed in today's digital world.
          </StoryText>
          
          <StoryText
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            With a focus on user experience and powerful features, we're committed to helping service businesses streamline their operations, improve customer satisfaction, and increase their bottom line. Join us in revolutionizing the way service businesses operate.
          </StoryText>
        </AboutSection>

        <Form />
      </Content>
    </PageContainer>
  );
};

export default AboutUs;